import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import Icon from '../../../components/AppIcon';

const SocialShare = ({ article }) => {
  const [showTooltip, setShowTooltip] = useState(false);
  const [copiedLink, setCopiedLink] = useState(false);

  const shareUrl = `https://edrianbass.com/blog/${article?.id}`;
  const shareText = article?.title;

  const socialPlatforms = [
    {
      name: 'Twitter',
      icon: 'Twitter',
      color: '#1DA1F2',
      url: `https://twitter.com/intent/tweet?text=${encodeURIComponent(shareText)}&url=${encodeURIComponent(shareUrl)}`
    },
    {
      name: 'LinkedIn',
      icon: 'Linkedin',
      color: '#0A66C2',
      url: `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(shareUrl)}`
    },
    {
      name: 'Facebook',
      icon: 'Facebook',
      color: '#1877F2',
      url: `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(shareUrl)}`
    },
    {
      name: 'WhatsApp',
      icon: 'MessageCircle',
      color: '#25D366',
      url: `https://wa.me/?text=${encodeURIComponent(shareText + ' ' + shareUrl)}`
    }
  ];

  const handleCopyLink = () => {
    navigator.clipboard?.writeText(shareUrl);
    setCopiedLink(true);
    setTimeout(() => setCopiedLink(false), 2000);
  };

  const handleShare = (url) => {
    window.open(url, '_blank', 'width=600,height=400');
  };

  return (
    <div className="relative">
      <motion.button
        whileHover={{ scale: 1.05 }}
        whileTap={{ scale: 0.95 }}
        onClick={() => setShowTooltip(!showTooltip)}
        className="flex items-center gap-2 px-4 py-2 bg-card border border-border rounded-lg hover:border-primary transition-colors"
      >
        <Icon name="Share2" size={18} color="currentColor" />
        <span className="text-sm font-medium">Share</span>
      </motion.button>
      <AnimatePresence>
        {showTooltip && (
          <motion.div
            initial={{ opacity: 0, y: 10, scale: 0.95 }}
            animate={{ opacity: 1, y: 0, scale: 1 }}
            exit={{ opacity: 0, y: 10, scale: 0.95 }}
            transition={{ duration: 0.2 }}
            className="absolute top-full mt-2 right-0 bg-card border border-border rounded-xl shadow-xl p-4 z-50 w-64"
          >
            <div className="flex items-center justify-between mb-3">
              <span className="text-sm font-semibold text-foreground">Share Article</span>
              <button
                onClick={() => setShowTooltip(false)}
                className="w-6 h-6 flex items-center justify-center rounded hover:bg-muted transition-colors"
              >
                <Icon name="X" size={14} color="currentColor" />
              </button>
            </div>

            <div className="grid grid-cols-4 gap-2 mb-3">
              {socialPlatforms?.map((platform) => (
                <motion.button
                  key={platform?.name}
                  whileHover={{ scale: 1.1 }}
                  whileTap={{ scale: 0.9 }}
                  onClick={() => handleShare(platform?.url)}
                  className="flex flex-col items-center gap-1 p-2 rounded-lg hover:bg-muted transition-colors"
                  title={`Share on ${platform?.name}`}
                >
                  <Icon name={platform?.icon} size={20} color={platform?.color} />
                  <span className="text-xs text-muted-foreground">{platform?.name}</span>
                </motion.button>
              ))}
            </div>

            <div className="pt-3 border-t border-border">
              <button
                onClick={handleCopyLink}
                className="w-full flex items-center justify-center gap-2 px-3 py-2 bg-muted rounded-lg hover:bg-primary hover:text-primary-foreground transition-colors"
              >
                <Icon name={copiedLink ? "Check" : "Link"} size={16} color="currentColor" />
                <span className="text-sm font-medium">
                  {copiedLink ? 'Link Copied!' : 'Copy Link'}
                </span>
              </button>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
};

export default SocialShare;